import React from 'react';
import { useRevShare } from '../../../hooks';
import { useCurrentModule } from '../../ModuleProvider';
import { getTranslationTags } from '../getTranslationTags';
export const SelectCycleDisclaimer = () => {
  var _taxStatus$data;
  const module = useCurrentModule();
  const {
    t,
    Trans
  } = module.internals.useTranslations();
  const taxStatus = module.SDK.studioOfferingApiClient.hooks.useFetchTaxStatus({});
  const {
    hasRevShare
  } = useRevShare();
  const isResellerOffering = false; // TODO: Implement (https://wix.atlassian.net/browse/PREM2-25146)
  const isPricesIncludeTax = ((_taxStatus$data = taxStatus.data) == null ? void 0 : _taxStatus$data.treatment) === 'INCLUSIVE'; // TODO: Improve

  if (hasRevShare) {
    // TODO: What if the prices include tax? The content is only for excluded tax
    return /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "studio_package_picker.billing_cycle_revshare.disclaimer",
      components: getTranslationTags({
        url: t('studio_package_picker.billing_cycle_revshare.disclaimer_link')
      })
    });
  }
  if (isResellerOffering) {
    if (isPricesIncludeTax) {
      return t('page_footer.reseller_sale.cycle_disclaimer');
    } else {
      return t('page_footer.reseller_sale.cycle_disclaimer_no_tax');
    }
  }
  if (!isPricesIncludeTax) {
    return /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "page_footer.subscription_disclaimer_applicable_tax",
      components: getTranslationTags({})
    });
  }
  return null;
};
//# sourceMappingURL=SelectCycleDisclaimer.js.map